export default __webpack_public_path__ + "static/media/portfolio-hover-171.71ed9e04.jpg";